export default __webpack_public_path__ + "static/media/empty-data-5.16e6c5bf.svg";